/**
 *
 * Audiences
 *
 */

import React, { useState, useEffect, useCallback, useMemo } from 'react';
import classNames from 'classnames';
import { useLocation, useParams } from 'react-router-dom';

// styles
import './style.scss';

// antd component
import { Button, Dropdown, Menu, Input } from 'antd';

// assets
import { DownOutlined } from '@ant-design/icons';
// import CustomIcons from 'components/CustomIcons';

// components
import ErrorBoundary from 'engine/ErrorBoundary';
import CustomPageHeader from 'components/CustomPageHeader';
import GoBackButton from 'components/GoBackButton';

// helper for forms
import { parseQuery } from 'utils/history';

function AudienceHeader({
  // main
  currentElement,
  // states
  loadingUpdate,
  loadingDelete,
  // actions
  onSave,
  onDelete,
  onAddNewMember,
  updateElement,
  onGoBack,
  //default
  className,
}) {
  const childClassNames = classNames('audiences-header-wrapper', className);
  const newKey = 'nouvel';
  const location = useLocation();
  const { id: initId } = useParams();

  const [name, setCurrenName] = useState(currentElement?.title || '');

  /**
   * Loading data for rendering in a component
   * - work like ComponentDidUpdate
   */
  useEffect(() => {
    return () => {
      // Anything in here is fired on component unmount.
      // Clearing the state after unmounting a component
    };
  }, []);

  const actionDropdownCallback = useCallback(
    async actionKey => {
      switch (actionKey.key) {
        case 'student':
        case 'teacher':
        case 'admin':
          onAddNewMember(actionKey.key);
          break;

        case 'delete':
          if (initId && initId !== newKey) {
            !!onDelete && onDelete(initId);
          } else if (initId == newKey) {
            !!updateElement && updateElement(false);
          }
          break;
      }
    },
    [initId, location.search, currentElement],
  );

  const actionsMenu = useMemo(() => {
    const menuItems = [
      {
        key: 'student',
        icon: null,
        label: 'Ajouter un étudiant',
        disabled: false,
      },
      {
        key: 'teacher',
        icon: null,
        label: 'Ajouter un enseignant',
        disabled: false,
      },
      {
        key: 'admin',
        icon: null,
        label: 'Ajouter un administrateur',
        disabled: false,
      },
      {
        key: 'delete',
        icon: null,
        label: `Supprimer l’audience`,
        disabled: loadingUpdate || loadingDelete,
        danger: true
      },
    ];
    return (
      <Menu onClick={actionDropdownCallback} items={menuItems} />
/*         <Menu.Item key="student">Ajouter un étudiant</Menu.Item>
        <Menu.Item key="teacher">Ajouter un enseignant</Menu.Item>
        <Menu.Item key="admin">Ajouter un administrateur</Menu.Item>
        <Menu.Item
          key="delete"
          disabled={loadingUpdate || loadingDelete}
          danger
        >
          Supprimer l’audience
        </Menu.Item>
      </Menu> */
    );
  }, [actionDropdownCallback, loadingUpdate, loadingDelete]);

  const onChangeName = useCallback(
    e => {
      const value = e?.target?.value;
      setCurrenName(value);
      !!updateElement && updateElement({ ...currentElement, title: value });
    },
    [updateElement, currentElement],
  );

  const NameFiled = useMemo(
    () => (
      <div className="audience-title-wrapper">
        <span className="label">Nom de l’audience</span>
        <Input
          value={name || currentElement?.title}
          placeholder="Nom de l’audience"
          disabled={loadingUpdate || loadingDelete}
          onChange={onChangeName}
        />
      </div>
    ),
    [name, currentElement?.title, loadingUpdate, loadingDelete],
  );

  // render function
  return (
    <div className={childClassNames}>
      <ErrorBoundary>
        {!!onGoBack && (
          <GoBackButton onGoBack={onGoBack} />
        )}
        
        <CustomPageHeader
          className="audiences-header"
          title={currentElement?.title || 'Nouvel Audience'}
          subTitle="Listes des audiences / audience"
          subTitlePosition="top"
          extraActions={[
            <Dropdown
              className="audiences-actions"
              trigger={['click']}
              overlay={actionsMenu}
              getPopupContainer={trigger => trigger.parentElement}
              overlayClassName="communication-actions__menu"
            >
              <Button>
                <span className="dropdownLabel">Actions</span>
                <DownOutlined />
              </Button>
            </Dropdown>,
            !!onSave && (
              <Button
                className="ant-btn-submit audience-submit"
                type="default"
                onClick={onSave}
              >
                Sauvegarder
              </Button>
            ),
          ]}
        />
        {NameFiled}
      </ErrorBoundary>
    </div>
  );
}

AudienceHeader.propTypes = {};

export default AudienceHeader;
